import enterpriseInformationApiSlice from "./enterpriseInformationApiSlice";
import UserRepository from "../repositories/UserRepository";
import config from "../config";
import { LeaveChanges } from "unmsght-report-package";
import { SERVICE_IDENTIFIERS } from "../constants";

const odsApiSlice = enterpriseInformationApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getODSPortalUserPermissions: builder.query({
            queryFn: async (_arg, _api, _extraOptions, baseQuery) => {
                const result = await baseQuery({
                    url: `portal-users/${process.env.REACT_APP_API_VERSION}/permissions${config.REACT_APP_ENV_NAME}`,
                    method: "GET",
                    params: {
                        serviceIdentifier: SERVICE_IDENTIFIERS.LEAVE_REPORTING,
                    },
                });

                if (result.error) {
                    return { error: result.error };
                }

                return {
                    data: UserRepository.formatOdsUserResponse(result.data),
                };
            },
            invalidatesTags: (_) => ["odsPortalUserPermissions"],
        }),
        getODSLeaveChanges: builder.query({
            query: ({
                isfOrganizationIds,
                startDate,
                startIndex,
                endDate,
                startPage,
                count,
                reportingGroups,
            }) => ({
                url: `leaves/${process.env.REACT_APP_API_VERSION}/leave-changes${config.REACT_APP_ENV_NAME}`,
                method: "GET",
                params: {
                    startPage,
                    startIndex,
                    count,
                    effectiveStartDt: startDate,
                    effectiveEndDt: endDate,
                    reportingGroup: reportingGroups,
                    organizationId: isfOrganizationIds.map((id) =>
                        String(id).toUpperCase()
                    ),
                },
            }),
            invalidatesTags: (_) => ["changesReport"],
            transformResponse: (response) => {
                return LeaveChanges.format(response);
            },
        }),
    }),
    overrideExisting: false,
});
export const {
    useLazyGetODSPortalUserPermissionsQuery,
    useLazyGetODSLeaveChangesQuery,
} = odsApiSlice;

export default odsApiSlice;
